import Decimal from 'decimal.js-light';

export const formatToPercentage = (
  value: string | number,
  decimals: number,
) => {
  if (!value) return '';
  return new Decimal(value).times(100).toFixed(decimals);
};

export const sumPercentages = (values: Record<string, number>) => {
  return Object.values(values).reduce((accumulator, value) => {
    return +accumulator + +value;
  }, 0);
};
